import { connect } from 'react-redux';
import { Selectors as Templates } from 'sections/assets/state/templates';
import { Selectors as RulesetSplitTests } from 'sections/campaigns/state/rulesetSplitTests';
import { State } from 'store';
import { Props, TemplatePercentageSummary } from './templatePercentageSummary';

interface OwnProps {
  rulesetSplitTestId: string;
}

export const mapStateToProps = (state: State, ownProps: OwnProps): Props => {
  const splitTest = RulesetSplitTests.getEntity(state, ownProps.rulesetSplitTestId);
  const variantTemplate = splitTest && Templates.getEntity(state, splitTest.variants[0].templateId);
  const variantWeight = splitTest && splitTest.variants[0].weight;
  return {
    templatePercentage: variantTemplate
      ? {
          name: variantTemplate.name,
          percentage: variantWeight,
        }
      : null,
  };
};

export default connect(mapStateToProps)(TemplatePercentageSummary);
